const PINTS_PER_LITRE = 1.7598;
const PINTS_PER_GALLON = 8;

export const getRetailServingDetails = (product: {
  containerType?: string | null;
  volume?: number | null;
  unit?: string | null;
  packQuantity?: number | null;
}) => {
  const container = product.containerType?.toLowerCase() ?? "";
  const isDraught =
    container.includes("keg") ||
    container.includes("cask") ||
    container === "flatbottompin" ||
    container === "polypin";
  const volume = product.volume ?? 1;
  let servings = product.packQuantity ?? 1;
  if (isDraught) {
    if (product.unit === "L") servings = volume * PINTS_PER_LITRE;
    else if (product.unit === "ml")
      servings = (volume * PINTS_PER_LITRE) / 1000;
    else if (product.unit === "gal") servings = volume * PINTS_PER_GALLON;
  }
  return { isDraught, servings };
};

/** Inputs and outputs are minor units. Estimates retain fractional VAT until the final serving-price rounding. */
export const estimateRetailServingPrice = ({
  priceExVat,
  vatPercentage,
  grossProfitMarginPercentage,
  servings,
}: {
  priceExVat: number;
  vatPercentage: number;
  grossProfitMarginPercentage: number;
  servings: number;
}) => {
  if (
    !Number.isFinite(grossProfitMarginPercentage) ||
    grossProfitMarginPercentage === 0 ||
    grossProfitMarginPercentage >= 100 ||
    !Number.isFinite(servings) ||
    servings <= 0
  ) {
    return { sellingPrice: 0, profitAfterVat: 0 };
  }
  const netSellingPrice = priceExVat / (1 - grossProfitMarginPercentage / 100);
  return {
    sellingPrice: Math.round(
      (netSellingPrice * (1 + vatPercentage / 100)) / servings,
    ),
    profitAfterVat: Math.round((netSellingPrice - priceExVat) / servings),
  };
};
